import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";
import Toggle from 'material-ui/Toggle';
import _ from "lodash";


export default class GiftcardConfig extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isGiftCardConfigEnable: false,
            errors: {},
            isLoaded: true,
            activeLocation: '',
            isBtnDisabled: true,
            fields: {}
        }

        this._bind(
            'handleChangeToggle',
            'handleCancel',
            'handleValidation',
            'loadGiftCardConfig',
            'updateConfigStatusToDatabase'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        // this.loadAutoAcceptConfig();
    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        }, () => {
            this.loadGiftCardConfig();
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null && nextProps.isLoaded == true) {

            this.setState({
                    activeLocation: nextProps.activeLocation
                },
                () => {
                    this.loadGiftCardConfig();
                });
        }
    }

    handleChangeToggle = (event, eventValue) => {

        let fields = this.state.fields;
        let activeLocation = this.state.activeLocation;
        let giftCardConfig = activeLocation.giftCardConfig;

        let btnDisabled = true;

        if (!Utils.isEmptyObj(giftCardConfig)) {
            btnDisabled = false;
        }

        fields["enable"] = eventValue;

        this.setState({
            isGiftCardConfigEnable: eventValue,
            fields: fields,
            isBtnDisabled: btnDisabled
        });
    };

    handleCancel() {
        this.props.reloadLocation();
        this.setState({
            errors: "",
            isBtnDisabled: true
        });
    };

    handleChange(field, e) {
        let value = e.target.value;

        let fields = this.state.fields;
        fields[field] = value;

        this.setState({fields, isBtnDisabled: false, errors: {}});
    }

    loadGiftCardConfig() {
        let activeLocation = this.state.activeLocation;

        if (!Utils.isEmptyObj(activeLocation)) {

            // Deep Clone of giftCardConfig Object to update the value in local
            let giftCardConfig = _.cloneDeep(activeLocation.giftCardConfig);
            let field = {};

            if (!Utils.isEmptyObj(giftCardConfig)) {
                this.setState({
                    fields: giftCardConfig,
                    isGiftCardConfigEnable: giftCardConfig.enable
                })
            } else {
                field["enable"] = false;
                field["provider"] = "GiftUp";
                field["token"] = "";
                field["id"] = "";

                this.setState({
                    fields: field,
                    isGiftCardConfigEnable: false
                })
            }
        }
    }

    handleValidation() {
        let fields = this.state.fields;
        let isGiftCardConfigEnable = this.state.isGiftCardConfigEnable;
        let error = {};
        let formIsValid = true;

        if (isGiftCardConfigEnable && Utils.isEmpty(fields.token)) {
            formIsValid = false;
            error["token"] = "Token field cannot be empty";
            this.setState({errors: error})
            return formIsValid;
        }

        return formIsValid;
    }

    updateConfigStatusToDatabase(e) {
        e.preventDefault();

        let self = this;
        let fields = this.state.fields;
        let activeLocation = this.state.activeLocation;

        if (!self.handleValidation()) {
            return;
        }

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let locId = activeLocation.objectId;
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        let paramsObject = {
            "objectId": locId,
            "giftCardConfig": fields
        };

        this.setState({isLoaded: false});
        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;

                    alert("Gift card config are updated successfully.");

                    self.setState({
                        isBtnDisabled: true,
                        isLoaded: true
                    });

                    // Reload the data
                    self.props.reloadLocation();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);

                }
            );


    }


    render() {

        let fields = this.state.fields;

        return (
            <div className="order-notification">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.errors["errors"] ? (
                        <div className="alert alert-danger text-center" role="alert">
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                }
                <div className="border-class marginTop">
                    <h4 id="translations" className="page-header">Update Gift Card Settings</h4>

                    <form name="updateLocationForm"
                          className="updateLocationForm"
                          onSubmit={this.updateConfigStatusToDatabase.bind(this)}
                    >
                        <div className="row form-group mb-0">
                            <div className="col-lg-12">
                                <div className="form-group mb-0">
                                    <label htmlFor="exampleInputPassword1">Gift Card
                                        Settings</label>
                                    <Toggle
                                        id={"isAnnouncementNotifyEnable"}
                                        defaultToggled={this.state.isGiftCardConfigEnable}
                                        onToggle={this.handleChangeToggle}
                                        style={{marginTop: 5, width: '100px'}}
                                        thumbSwitchedStyle={{backgroundColor: '#008000'}}
                                        trackSwitchedStyle={{backgroundColor: '#8fbc8f'}}
                                    />

                                    <h5 className={"mb-0"}>
                                       Gift Card is <strong>{this.state.isGiftCardConfigEnable ? "Enabled" : "Disabled"}</strong>
                                    </h5>

                                    {
                                        this.state.isGiftCardConfigEnable == true ?

                                            <div>
                                                <hr></hr>

                                                <div className="row form-group mb-5">
                                                    <div className="col-lg-6">
                                                        <div className="form-group msg-contained mb-5">
                                                            <label htmlFor="labelName">Access
                                                                Token</label>
                                                            <input
                                                               type="text"
                                                               className={`form-control ${
                                                                   !Utils.isEmptyObj(this.state.errors["token"]) ? 'input-error' : null}`}
                                                               id="access_token"
                                                               ref="access_token"
                                                               aria-describedby="access_token"
                                                               placeholder="Enter Your Token"
                                                               onChange={this.handleChange.bind(this, "token")}
                                                               value={fields.token || ""}
                                                            />

                                                            {!Utils.isEmptyObj(this.state.errors["token"]) ? (
                                                                <span className="form-text text-red ft-14">
                                                                    {this.state.errors["token"]}
                                                                </span>
                                                            ) : null}

                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group msg-contained mb-5">
                                                            <label htmlFor="labelName">
                                                                Location Id
                                                                <span className="form-text text-muted">(Optional)</span>
                                                            </label>
                                                            <input
                                                               type="text"
                                                               className={`form-control`}
                                                               id="locId" ref="locId"
                                                               aria-describedby="locId"
                                                               placeholder="Enter Your Location Id"
                                                               onChange={this.handleChange.bind(this, "id")}
                                                               value={fields.id || ""}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        : null

                                    }

                                </div>
                            </div>
                        </div>

                        <hr></hr>

                        <div className="form-group">
                            <button type="submit"
                                    className={this.state.isBtnDisabled ? "btn-save btn btn-export" : "btn btn-export"}>Save
                            </button>
                            <button type="button" className="btn btn-default back-button"
                                    onClick={this.handleCancel}>Cancel
                            </button>

                        </div>
                        <hr></hr>

                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/giftcard-config.js